export default "__VITE_ASSET__DltEUmSq__"